<template>
    <div class="search-bar">
        <label v-show="!isShow" @click="handleEdit">
            <i></i>
            {{ placeholder }}
        </label>
        <div v-show="isShow" class="input-box">
            <div class="input-box-text">
                <input
                    :value="value"
                    class="needsclick"
                    @input="changeInput"
                    @keyup.enter="handleSearch"
                    ref="search"
                    :placeholder="placeholder"
                />
                <i v-show="value" @click.stop="handleClear"> </i>
            </div>
            <span class="btn-search" @click="handleSearch">搜索 </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "SearchBar",
    props: {
        // 搜索内容
        value: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "搜索",
        },
    },
    data() {
        return {
            isShow: false, // 是否显示输入框
        };
    },
    methods: {
        /* 编辑输入框 */
        handleEdit() {
            this.isShow = !this.isShow;
            this.$nextTick(() => {
                this.$refs.search.focus();
            });
        },
        /* 清除输入框 */
        handleClear() {
            this.$emit("input", "");
            this.$nextTick(() => {
                this.$refs.search.focus();
            });
        },
        /* 搜索 */
        handleSearch() {
            this.$emit("search");
        },
        changeInput(event) {
            const text = event.target.value;
            this.$emit("input", text);
        },
    },
};
</script>

<style lang="less" scoped>
.search-bar {
    padding: 16px 20px;
    background: #fff;
    width: 100%;
    height: 100px;
    line-height: 70px;
    box-sizing: border-box;
    font-size: 28px;
    overflow: hidden;

    label {
        background: #f2f2f2;
        border-radius: 4px;
        display: inline-block;
        width: 100%;
        height: 100%;
        text-align: center;
        color: #999;

        i {
            display: inline-block;
            vertical-align: middle;
            height: 100%;
            width: 40px;
            background: url(../public/images/index/search-icon.png) center 16px
                no-repeat;
            background-size: 80%;
            margin-right: 10px;
        }
    }

    .input-box {
        height: 100%;

        .input-box-text {
            float: left;
            width: 630px;
            height: 100%;
            position: relative;

            input {
                width: 100%;
                height: 100%;
                background: #f2f2f2;
                border-radius: 4px;
                border: 0;
                padding-left: 20px;
                padding-right: 100px;
                box-sizing: border-box;

                &::-webkit-input-placeholder {
                    color: #999;
                }
            }

            i {
                position: absolute;
                top: 50%;
                right: 20px;
                width: 32px;
                height: 32px;
                margin-top: -16px;
                background: url(../public/images/index/search-delete-icon.png)
                    center no-repeat;
                background-size: 100%;
            }
        }

        .btn-search {
            float: right;
            width: 70px;
            height: 100%;
            text-align: center;
            color: #666;
        }
    }
}
</style>
